import {Checkbox} from 'antd';
import React, {FC} from 'react';

import {IFieldMeta} from 'entities/metadata';
import {TEntityValue} from 'modules/data';

export interface IBoolFieldProps {
    value: TEntityValue;
    onChange?: (value: any) => void;
    disabled?: boolean;
    entityName: string;
    handleChangeActiveKey?: (key: string, id: number) => void;
    checkKey?: any;
    field: IFieldMeta;
    record: any;

}

export const CheckboxField: FC<IBoolFieldProps> = ({
    value,
    onChange,
    disabled,
    field,
    record,
    handleChangeActiveKey,
    checkKey,
    ...props
}: IBoolFieldProps) => {
    const {key} = field;
    const isCurrentChecked = checkKey[record.id] === key;

    const handleChange = async () => {
        if (onChange) onChange(value);
        if (handleChangeActiveKey) handleChangeActiveKey(key, record);
    };

    return (
        <Checkbox
            {...props}
            onChange={handleChange}
            checked={isCurrentChecked}
            value={value}
            disabled={disabled}
        />
    );
};
